import { useTranslation } from 'react-i18next';
import { useSiteImage } from '@/hooks/useSiteImage';

export default function HeroBanner() {
  const { t } = useTranslation();
  // Same admin-managed brand logo as the footer (Header & Footer → Brand Logo).
  const brandLogoUrl = useSiteImage('footer.logo', '/brand/rxk-logo-footer.png');

  return (
    <section className="relative w-full min-h-[60vh] bg-[#1A1A1A] flex items-center justify-center overflow-hidden">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#1A1A1A] via-[#1A1A1A] to-[#1B3A5C]/15 pointer-events-none" />

      <div className="relative z-10 flex flex-col items-center text-center gap-5 px-6 pt-20 pb-16 max-w-3xl">
        {/* Section label */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-px bg-[#7B1113]" />
          <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">
            {t('brandStory.hero.label')}
          </span>
          <div className="w-8 h-px bg-[#7B1113]" />
        </div>

        {/* Heading */}
        <div className="flex flex-col gap-1">
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1]">
            {t('brandStory.hero.heading')}
          </h1>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light italic text-white/50 leading-[1.1]">
            {t('brandStory.hero.subheading')}
          </h2>
        </div>

        {/* Subtitle */}
        <p className="text-sm text-white/40 font-light tracking-wide">
          {t('brandStory.hero.subtitle')}
        </p>

        {/* Brand mark */}
        <img src={brandLogoUrl} alt="Rx.K Seoul" className="h-14 w-auto mt-2" />
      </div>
    </section>
  );
}